import { createAsyncThunk } from "@reduxjs/toolkit";
import { blogApi, blogApiByID, blogDetailBySlugApi } from "./blog.wpapi";
const USE_BLOG_SLUG = process.env.REACT_APP_USE_BLOG_SLUG === "TRUE";

export const fetchBlogs = createAsyncThunk("blogs/get", async () => {
  const response = await blogApi();
  return response;
});

export const fetchBlogDetails = createAsyncThunk(
  "blog-detail/get",
  async (slugOrId, { rejectWithValue }) => {
    if (USE_BLOG_SLUG) {
      const response = await blogDetailBySlugApi(slugOrId);
      if (!response) return rejectWithValue("Post not found");
      return response;
    }
    return blogApiByID(slugOrId);
  },
);
